module.exports = __webpack_public_path__ + "static/media/diag2.29ea8cfe.png";